import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss';
import { PortfolioContent } from '../data/content';

interface TimelineProps {
  content: PortfolioContent['timeline'];
}

function Timeline({ content }: TimelineProps) {
  return (
    <div className="timeline-wrapper" id="history">
      <div className="items-container">
        <h1>{content.heading}</h1>
        <VerticalTimeline lineColor="#E0E0E0">
          {content.items.map((item, idx) => (
            <VerticalTimelineElement
              key={idx}
              className={`vertical-timeline-element--${item.type}`}
              contentStyle={{
                background: '#F5F5F5',
                color: '#1F1F1F',
                border: '1px solid #E0E0E0',
                boxShadow: 'none',
                borderRadius: '8px',
              }}
              contentArrowStyle={{ borderRight: '7px solid #E0E0E0' }}
              date={item.date}
              iconStyle={{ background: '#2B2B2B', color: '#FFFFFF' }}
              icon={<FontAwesomeIcon icon={item.type === 'education' ? faGraduationCap : faBriefcase} />}
            >
              <h3 className="vertical-timeline-element-title">{item.title}</h3>
              <h4 className="vertical-timeline-element-subtitle">{item.subtitle}</h4>
              <ul className="timeline-points">
                {item.points.map((pt, pIdx) => (
                  <li key={pIdx}>{pt}</li>
                ))}
              </ul>
            </VerticalTimelineElement>
          ))}
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;